<wl-calculate-card
  [title]="rendering().fields.Title"
  [subTitle]="rendering().fields.Description"
  [sticker]="rendering().fields.Sticker"
>
  <wl-solar-panels-wizard-ui
    [rendering]="rendering()"
    [form]="form()"
    [trackStep]="trackToolConfig().forStep('wizard')"
    [submitState]="submitState()"
    (formSubmit)="submit()"
    (openConsumptionDialog)="openConsumptionDialog()"
  ></wl-solar-panels-wizard-ui>
</wl-calculate-card>
